export default "/fonts/vendor/katex/dist/KaTeX_SansSerif-Italic.woff?8d593cfaa96238d5e2f8af9e11cc5a68";